import { Section } from '../entities/Section'

import { pksApiService } from '../services/pksApiService'

class SectionCommunicator {
    async fetchSections() {
        const sectionsEndpoint = '/sections'

        const sections = await pksApiService.fetchData(sectionsEndpoint)
        return sections.map(item => new Section(item))
    }

    async fetchSingleSection(slug) {
        const sectionsEndpoint = `/sections/${slug}`
        const singleArticle = await pksApiService.fetchData(sectionsEndpoint)

        return new Section(singleArticle)
    }
}

export const sectionCommunicator = new SectionCommunicator()
